import styled from 'styled-components';

export const Container = styled.div`
    width: ${props => (props.hasWidth  ? props.hasWidth : '352px')};
    height: ${props => (props.hasheight  ? props.hasheight : '400px')};
    background: #eff3f4 0% 0% no-repeat padding-box;
    border-radius: 16px 16px 16px 16px;
`;

export const GridHeader = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const HeaderArea = styled.div`
    width: ${props => (props.hasWidth  ? props.hasWidth : '265px')};
    height: ${props => (props.hasheight  ? props.hasheight : '73px')};
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border-top: 0.5px solid #EFEAE8;
    border-bottom: 0.5px solid #EFEAE8;
    border-right: 0.5px solid #EFEAE8;
    border-radius: 0px 16px 0px 0px;
    display: flex;
    justify-content: left;
    align-items: center;
    flex-direction: row;
    padding-left: 17px;
    text-align: left;
    font: normal normal 600 18px/22px Mangueira;
    color: #000000;
`;

export const IconArea = styled.div`
    width: ${props => (props.hasWidth  ? props.hasWidth : '87px')};
    height: ${props => (props.hasheight  ? props.hasheight : '73px')};
    background: #EFEAE8 0% 0% no-repeat padding-box;
    border-radius: 16px 0px 0px 0px;
    display: flex;
    justify-content: center;
`;

export const Icon = styled.img`
    width: ${props => (props.hasWidth  ? props.hasWidth : '50px')};
    height: auto;
`;
